(function () {
  const SELECT_SELECTOR = '[js-rebuy-select]';
  const HEADER_SELECTOR = '[js-rebuy-select-header]';
  const ITEM_SELECTOR = '.rebuy-product__select-dropdown-item';

  document.addEventListener('click', function (e) {
    const select = e.target.closest(SELECT_SELECTOR);
    const header = e.target.closest(HEADER_SELECTOR);

    if (header && select) {
      e.stopPropagation();

      document.querySelectorAll(`${SELECT_SELECTOR}.is-open`).forEach(el => {
        if (el !== select) el.classList.remove('is-open');
      });

      select.classList.toggle('is-open');
      return;
    }
    if (e.target.closest(ITEM_SELECTOR) && select) {
      select.classList.remove('is-open');
      return;
    }

    if (!select) {
      document.querySelectorAll(`${SELECT_SELECTOR}.is-open`)
        .forEach(el => el.classList.remove('is-open'));
    }
  });
})();